/** @namespace Constants */

/**
 * @constant {string}
 * @memberof Constants
 */
export const GREENHOUSE_GUIDANCE = 'https://datapeople-customer.docsend.com/v/9h9tc/greenhouse-integration';

/**
 * @constant {string}
 * @memberof Constants
 */
export const WORKDAY_GUIDANCE = 'https://datapeople-customer.docsend.com/v/9h9tc/workday-integration';

/**
 * @constant {string}
 * @memberof Constants
 */
export const SUCCESSFACTORS_GUIDANCE = 'https://datapeople-customer.docsend.com/v/9h9tc/successfactors-integration';

/**
 * @constant {string}
 * @memberof Constants
 */
export const ICIMS_GUIDANCE = 'https://datapeople-customer.docsend.com/v/9h9tc/icims-integration';
